export const skillCategories = [
  {
    category: "AI & Machine Learning",
    skills: [
      {
        name: "Large Language Models",
        shortName: "LLM",
        proficiency: 95,
        color: "#8B5CF6",
        description: "Master-level understanding of GPT, Claude, and Groq architectures"
      },
      {
        name: "LangChain",
        shortName: "LangChain",
        proficiency: 90,
        color: "#10B981",
        description: "Expert in chaining language model operations"
      },
      {
        name: "TensorFlow",
        shortName: "TensorFlow",
        proficiency: 85,
        color: "#F97316",
        description: "Deep neural network construction and training"
      },
      {
        name: "Hugging Face",
        shortName: "HF",
        proficiency: 90,
        color: "#FFD700",
        description: "Transformer model fine-tuning and deployment"
      },
      {
        name: "RAG Systems",
        shortName: "RAG",
        proficiency: 92,
        color: "#00D9FF",
        description: "Retrieval-Augmented Generation architectures"
      }
    ]
  },
  {
    category: "Programming",
    skills: [
      {
        name: "Python",
        shortName: "Python",
        proficiency: 95,
        color: "#3B82F6",
        description: "Supreme mastery of Python for ML and backend"
      },
      {
        name: "JavaScript",
        shortName: "JavaScript",
        proficiency: 85,
        color: "#FACC15",
        description: "Modern ES6+ and async programming"
      },
      {
        name: "FastAPI",
        shortName: "FastAPI",
        proficiency: 90,
        color: "#10B981",
        description: "High-performance API development"
      },
      {
        name: "React",
        shortName: "React",
        proficiency: 82,
        color: "#00D9FF",
        description: "Component-based UI construction"
      }
    ]
  },
  {
    category: "DevOps & Infrastructure",
    skills: [
      {
        name: "Docker",
        shortName: "Docker",
        proficiency: 88,
        color: "#2496ED",
        description: "Containerization and orchestration"
      },
      {
        name: "AWS",
        shortName: "AWS",
        proficiency: 85,
        color: "#FF9900",
        description: "EC2, S3, Lambda deployment mastery"
      },
      {
        name: "MongoDB",
        shortName: "MongoDB",
        proficiency: 90,
        color: "#47A248",
        description: "NoSQL database design and optimization"
      },
      {
        name: "Git",
        shortName: "Git",
        proficiency: 92,
        color: "#F05032",
        description: "Source control and collaboration"
      }
    ]
  }
];
